<template>
  <div id="live-update-controller">
    <div :class="{
      disconnected: !connected,
      'disconnected-shouldreload': shouldReload
    }">
      <font-awesome-icon v-show="checkConnect" :icon="faCircle" class="icon"  :title="connected ? $t('CONNECTED'): $t('DISCONNECTED')" />
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

export default {
  name: 'LiveUpdateController',
  components: {
    FontAwesomeIcon
  },
  props: {
    channel: {
      type: String,
      required: true
    },
    checkConnect: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    let ws;
    const connected = ref(false);
    const shouldReload = ref(false);

    const timerId = ref(0);
    const reconnectTime = ref(null);
    const reconnectionsCount = ref(0);
    const maxTimer = ref(6000000); // 10 minute

    const wsClose = () => {
      if (ws) {
        ws.close();
        ws = null;
      }
      connected.value = false;
      shouldReload.value = true;
      clearTimeout(reconnectTime.value);
      timerId.value = 0;
      reconnectTime.value = null;
      reconnectionsCount.value = 0;
    };

    const wsConnect = () => {
      if (ws) return;

      ws = new WebSocket(`${process.env.VUE_APP_CRM_WS_ROOT}/${props.channel}/`);

      ws.onmessage = (e) => {
        emit('signal', e);
      };

      ws.onopen = () => {
        connected.value = true;
        if(reconnectTime.value !== null) {
          clearTimeout(reconnectTime.value);
          timerId.value = 0;
          reconnectTime.value = null;
          reconnectionsCount.value = 0;
        }
      };

      const runReconnect = () => {
        if (reconnectionsCount.value <= 1) {
          reconnectTime.value = setTimeout(() => {
            wsConnect();
          }, 1000);
        } else {
          reconnectTime.value = setTimeout(() => {
            wsConnect();
            timerId.value += 3000;
          }, timerId.value);
        }
      };

      ws.onclose = () => {
        if (!ws) return;

        ws = null;
        connected.value = false;

        if (connected.value) {
          clearTimeout(reconnectTime.value);
          timerId.value = 1000;
          reconnectTime.value = null;
        }

        reconnectionsCount.value += 1;

        runReconnect();
      };

      // error will reconect
      ws.onerror = () => {
        if (timerId.value >= maxTimer.value) {
          wsClose();
          // will not reconect when > maxtimer;
        } else {
          ws.onclose();
        }
      };
    };

    onMounted(() => {
      wsConnect();
    });

    onUnmounted(() => {
      wsClose();
    });

    return {
      faCircle,
      connected,
      shouldReload
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#live-update-controller {
  .icon {
    transition: transform .2s;
    color: $shamrockGreen;

    &:hover {
      transform: scale(1.4);
    }


  }
  .disconnected {
    .icon {
      color: $geranium;
    }
  }

  .disconnected-shouldreload {
    .icon {
      color: $lavenderGrey;
    }
  }
}
</style>
